module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-angry-0037aa7e.svg";